"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.List = void 0;
const ArrayEnumerable_1 = require("../enumerables/ArrayEnumerable");
const BasicEnumerable_1 = require("../enumerables/BasicEnumerable");
const Grouping_1 = require("../enumerables/Grouping");
const OrderedEnumerable_1 = require("../enumerables/OrderedEnumerable");
const utilityFunctions_1 = require("../utilities/utilityFunctions");
class List extends ArrayEnumerable_1.ArrayEnumerable {
    constructor(collection) {
        const src = collection ? [...collection] : [];
        // Needed to avoid circular dependency
        const factory = {
            createBasicEnumerable(generator) {
                return new BasicEnumerable_1.BasicEnumerable(this, generator);
            },
            createOrderedEnumerable(generator) {
                return new OrderedEnumerable_1.OrderedEnumerable(this, generator);
            },
            createGroupedEnumerable(key, generator) {
                return new Grouping_1.Grouping(this, key, generator);
            },
            createArrayEnumerable(generator, srcArr) {
                return new ArrayEnumerable_1.ArrayEnumerable(this, generator, srcArr);
            },
            createList(generator) {
                return new List(generator());
            }
        };
        super(factory, (0, utilityFunctions_1.getIterableGenerator)(src), src);
    }
    get length() {
        return this.srcArr.length;
    }
    add(item) {
        this.srcArr.push(item);
    }
    addRange(collection) {
        this.srcArr.push(...collection);
    }
    clear() {
        this.srcArr.length = 0;
    }
    copyTo(indexOrArray, arrayOrArrayIndex, arrayIndex, count) {
        let arr;
        let startArrayIndex = 0;
        let startSrcIndex = 0;
        let endSrcIndex = this.srcArr.length;
        if (Array.isArray(indexOrArray)) {
            arr = indexOrArray;
            if (arrayOrArrayIndex !== undefined) {
                if (typeof arrayOrArrayIndex === 'number') {
                    startArrayIndex = arrayOrArrayIndex;
                }
                else {
                    throw new Error('Invalid use of overloads.');
                }
            }
        }
        else if (Array.isArray(arrayOrArrayIndex)) {
            arr = arrayOrArrayIndex;
            startSrcIndex = indexOrArray;
            if (arrayIndex === undefined || count === undefined) {
                throw new Error('Invalid use of overloads.');
            }
            startArrayIndex = arrayIndex;
            endSrcIndex = Math.min(startSrcIndex + count, this.srcArr.length);
        }
        else {
            throw new Error('Invalid use of overloads.');
        }
        for (let i = startSrcIndex, j = startArrayIndex; i < endSrcIndex; i++, j++) {
            arr[j] = this.srcArr[i];
        }
    }
    findIndex(startIndexOrPredicate, countOrPredicate, predicate) {
        let predicateFn;
        let start = 0;
        let end = this.srcArr.length;
        if (typeof startIndexOrPredicate === 'function') {
            predicateFn = startIndexOrPredicate;
        }
        else if (typeof countOrPredicate === 'function') {
            predicateFn = countOrPredicate;
            start = startIndexOrPredicate;
        }
        else {
            if (typeof countOrPredicate !== 'number') {
                throw new Error('Invalid use of overloads.');
            }
            predicateFn = predicate;
            start = startIndexOrPredicate;
            end = Math.min(start + countOrPredicate, this.srcArr.length);
        }
        if (predicateFn === undefined) {
            throw new Error('Invalid use of overloads.');
        }
        for (let i = start; i < end; i++) {
            if (predicateFn(this.srcArr[i], i)) {
                return i;
            }
        }
        return -1;
    }
    indexOf(item, index, count) {
        const start = index !== null && index !== void 0 ? index : 0;
        const end = count !== undefined ? Math.min(start + count, this.srcArr.length) : this.srcArr.length;
        for (let i = start; i < end; i++) {
            if (this.srcArr[i] === item) {
                return i;
            }
        }
        return -1;
    }
    insert(index, item) {
        if (index < 0 || index >= this.srcArr.length) {
            throw new Error('Index out of bounds.');
        }
        this.srcArr.splice(index, 0, item);
    }
    insertRange(index, collection) {
        if (index < 0 || index >= this.srcArr.length) {
            throw new Error('Index out of bounds.');
        }
        let i = index;
        for (const item of collection) {
            this.insert(i, item);
            i++;
        }
    }
    remove(item) {
        const index = this.srcArr.indexOf(item);
        if (index === -1) {
            return false;
        }
        this.srcArr.splice(index, 1);
        return true;
    }
    removeAll(predicate) {
        let removed = 0;
        const itemIndexesToRemove = [];
        for (let i = 0; i < this.srcArr.length; i++) {
            if (predicate(this.srcArr[i], i)) {
                itemIndexesToRemove.push(i);
            }
        }
        for (let i = itemIndexesToRemove.length - 1; i >= 0; i--) {
            this.removeAt(itemIndexesToRemove[i]);
            removed++;
        }
        return removed;
    }
    removeAt(index) {
        if (index < 0 || index >= this.srcArr.length) {
            throw new Error('Index out of bounds.');
        }
        this.srcArr.splice(index, 1);
    }
    removeRange(index, count) {
        if (index < 0 || index >= this.srcArr.length) {
            throw new Error('Index out of bounds.');
        }
        this.srcArr.splice(index, count);
    }
    reverseInPlace(index, count) {
        const start = index !== null && index !== void 0 ? index : 0;
        const end = count !== undefined ? Math.min(start + count, this.srcArr.length - 1) : this.srcArr.length - 1;
        if (start > this.srcArr.length || start < 0) {
            throw new Error('Index out of bounds.');
        }
        for (let i = start, j = end; i < j; i++, j--) {
            const temp = this.srcArr[i];
            this.srcArr[i] = this.srcArr[j];
            this.srcArr[j] = temp;
        }
    }
    sort() {
        this.srcArr.sort();
    }
}
exports.List = List;
//# sourceMappingURL=List.js.map